import { render, staticRenderFns } from "./Flash.vue?vue&type=template&id=2392a7ab&scoped=true"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"
import style0 from "./Flash.vue?vue&type=style&index=0&id=2392a7ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392a7ab",
  null
  
)

export default component.exports